import { useCallback } from 'react';
import { getFWN } from '@core/fwn';
import { logInfo } from '@core/logging';
/**
 * Provides access to the global renderScreenReaderAlert function
 * @returns
 */
export const useScreenReaderAlert = () => {
    return useCallback((...args) => {
        const alert = args[0];
        return (getFWN()?.renderScreenReaderAlert?.(...args) ||
            logInfo(`cannot render alert "${alert}",  window._fwn.renderScreenReaderAlert is undefined`, false));
    }, []);
};
